import React from 'react'
import type { FormControlProps as MuiFormControlProps } from '@material-ui/core/FormControl'
import MuiFormControl from '@material-ui/core/FormControl'

export type FormControlProps = MuiFormControlProps

const FormControl = React.forwardRef<HTMLDivElement, FormControlProps>(function FormControl(props, ref) {
  return <MuiFormControl ref={ref} {...props} />
})

export default FormControl
